import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { getSocketAuthEndpoint, getSocketHost, getSocketHostPort } from "./apiEndpoint";
import http from "./httpService";
import { getNotificationChannel } from "./authService";
import { Transport } from "pusher-js/types/src/core/config";

const authEndpoint = getSocketAuthEndpoint(),
  key = process.env.REACT_APP_PUSHER_KEY,
  cluster = process.env.REACT_APP_PUSHER_CLUSTER,
  headers = http.headers.common,
  notificationChannel = getNotificationChannel(),
  enrichmentChannel = 'marketplace.enrichment',
  systemCaseSavedChannel = 'systemCase.saved';


const initOptions = {
  broadcaster: "pusher",
  key,
  cluster,
  forceTLS: false,
  authEndpoint,
  wsHost: getSocketHost(),
  wsPort: parseInt(getSocketHostPort() || "80"),
  auth: { headers },
  disableStats: true,
  enabledTransports: ["ws", "wss"] as Transport[],
};

const options = {
  ...initOptions,
  client: new Pusher(key || "", initOptions),
};

const create = new Echo(options);

const connectToNotification = (socket: Echo, notify: (data: any) => void) => {
  if (key && notificationChannel) {
    socket.private(notificationChannel).notification(notify);
  }
};

const connectToEnrichment = (socket: Echo, notify: (data: any) => void) => {
  if (key && enrichmentChannel) {
    socket
      .private(enrichmentChannel)
      .listen("Marketplace\\AdEnrichmentCompleted", notify)
      .listen("Marketplace\\AdEnrichmentInferredCompleted", notify)
  }
}

const connectToSystemCaseSaved = (socket: Echo, callback: (data: any) => void) => {
  if (key && systemCaseSavedChannel) {
    socket
      .private(systemCaseSavedChannel)
      .listen("SystemCase\\BackofficeSavedBroadcast", callback)
      .listen("SystemCase\\SavedBroadcast", callback) // "SavedBroadcast" is depracated
      .listen("SystemCase\\Saved", callback)
      .listen("SystemCase\\Created", callback)
      .listen("SystemCase\\Accepted", callback)
  }
}

const disconnect = (socket: Echo) => {
  socket.disconnect();
};

const items = {
  create,
  connectToNotification,
  disconnect,
  connectToEnrichment,
  connectToSystemCaseSaved
};

export default items;
